import { Button } from '../../../../components/ui';
import { strings } from '../../../../strings/strings';

export const GridRequestCard = ({ request, isMutating, onApprove, onReject, formatDate }) => {
  const phone =
    request.mobile_code && request.mobile_number
      ? `${request.mobile_code} ${request.mobile_number}`
      : 'N/A';
  const fullName = `${request.first_name || ''} ${request.last_name || ''}`.trim();

  return (
    <div className="flex flex-col rounded-lg bg-white border border-[#e8edf5] shadow-[0_2px_12px_rgba(0,0,0,0.06)] overflow-hidden transition-shadow duration-200">
      <div className="p-5 pb-3 flex-1 flex flex-col gap-3.5">
        <p className="m-0 text-[15px] font-bold text-secondary leading-tight whitespace-nowrap overflow-hidden text-ellipsis">
          {fullName || "Unknown"}
        </p>
        <div className="flex flex-col gap-0.5 bg-slate-100 rounded-[10px] p-2">
          <InfoRow label="Referral Code" value={request.referral_code || "N/A"} />
          <InfoRow label="Phone" value={phone} />
          <InfoRow label="Hospital" value={request.hospital || "N/A"} />
          <InfoRow label="Country" value={request.country || "N/A"} />
          <InfoRow label="E-mail" value={request.email || "N/A"} />
        </div>

        <div className="flex items-center gap-1.5 py-1.5 border-t border-dashed border-slate-200 mt-auto">
          <span className="text-[11.5px] text-secondary font-medium flex-1">Requested Date</span>
          <span className="text-[11.5px] text-secondary font-bold">{formatDate(request.created_at)}</span>
        </div>
      </div>
      <div className="flex gap-2.5 px-5 py-3.5 border-t border-[#f1f5f9] bg-[#fafbfc] items-center">
        <button
          onClick={() => onReject(request)}
          disabled={isMutating}
          className="flex-1 flex items-center justify-center py-2 rounded-[10px] border-[1.5px] border-red-300 bg-white text-red-600 text-[13px] font-semibold cursor-pointer transition-all duration-200 hover:bg-red-50 hover:border-red-400 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {strings.reject}
        </button>
        <Button
          variant="primary"
          size="sm"
          onClick={() => onApprove(request)}
          disabled={isMutating}
          isLoading={isMutating}
          className="flex-1"
        >
          {strings.approve}
        </Button>
      </div>
    </div>
  );
};

const InfoRow = ({ label, value }) => (
  <div className="flex items-center px-2 py-1 rounded-md">
    <span className="text-xs text-secondary font-medium flex-1">{label}</span>
    <span className="text-[12.5px] text-secondary font-bold max-w-[55%] text-right overflow-hidden text-ellipsis whitespace-nowrap">
      {value || '—'}
    </span>
  </div>
);


export const ListRequestCard = ({ request, isMutating, onApprove, onReject, formatDate }) => {
  const fullName = `${request.first_name || ''} ${request.last_name || ''}`.trim();
  const phone =
    request.mobile_code && request.mobile_number
      ? `${request.mobile_code} ${request.mobile_number}`
      : 'N/A';

  return (
    <div className="flex items-stretch p-0 gap-0 bg-white border border-gray-200 rounded-sm shadow-sm overflow-hidden">
      <div className="grid grid-cols-2 gap-x-10 gap-y-1.5 flex-1 px-6 py-4 content-center">
        <p className="m-0 text-[15px] font-semibold text-secondary leading-tight whitespace-nowrap overflow-hidden text-ellipsis">
          {fullName || "Unknown"}
        </p>
        <LRow label="Email" value={request.email || "N/A"} />
        <LRow label="Referral Code" value={request.referral_code || "N/A"} />
        <LRow label="Phone" value={phone} />
        <LRow label="Hospital" value={request.hospital || "N/A"} />
        <LRow label="Country" value={request.country || "N/A"} />
        <LRow label="Requested Date" value={formatDate(request.created_at)} />
      </div>

      <div className="flex items-center shrink-0 px-[18px] py-[14px] border-l border-gray-200 justify-center">
        <div className="flex gap-2 items-center">
          <button
            onClick={() => onReject(request)}
            disabled={isMutating}
            className="px-3.5 py-1.5 rounded-md border border-red-300 bg-white text-red-600 text-[13px] font-medium cursor-pointer transition-all duration-150 whitespace-nowrap hover:bg-red-50 hover:text-red-600 hover:border-red-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {strings.reject}
          </button>
          <Button
            variant="primary"
            size="sm"
            onClick={() => onApprove(request)}
            disabled={isMutating}
            isLoading={isMutating}
          >
            {strings.approve}
          </Button>
        </div>
      </div>
    </div>
  );
};

const LRow = ({ label, value }) => (
  <div className="flex items-baseline gap-1.5 overflow-hidden">
    <span className="text-[11.5px] font-semibold text-secondary whitespace-nowrap shrink-0">
      {label}:
    </span>
    <span className="text-[12.5px] font-medium text-secondary overflow-hidden text-ellipsis whitespace-nowrap">
      {value}
    </span>
  </div>
);
